var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from 'globals/api';
import { SENIOR_SERVICE_END_POINTS } from 'globals/apiEndPoints';
import { getChunks } from 'globals/global.functions';
import uniqBy from 'lodash.uniqby';
/**
 * @function getSeniorListService
 * @description method to get senior list via api response.
 * @param {*} params
 * @returns ids: array of {senior_id, account_id}, LastEvaluatedKey
 */
export function getSeniorListService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: SENIOR_SERVICE_END_POINTS.GET_SENIOR_LIST,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_1 = _a.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * @function getSeniorMappingService
 * @description method to get senior data mapping
 * @param {IUserId[]} userList list of users to fetch data for
 * @returns object of Senior Data
 */
export function getSeniorMappingService(userList_1) {
    return __awaiter(this, arguments, Promise, function (userList, isPost) {
        var chunks, data, i, config, response, error_2;
        if (isPost === void 0) { isPost = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chunks = getChunks(uniqBy(userList, 'user_id'), 100);
                    data = {};
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < chunks.length)) return [3 /*break*/, 5];
                    config = isPost
                        ? {
                            method: 'post',
                            data: chunks[i],
                        }
                        : {
                            method: 'get',
                            params: { senior_mapping: JSON.stringify(chunks[i]) },
                        };
                    return [4 /*yield*/, API(__assign({ url: SENIOR_SERVICE_END_POINTS.GET_SENIOR_MAPPING }, config))];
                case 3:
                    response = _a.sent();
                    data = __assign(__assign({}, data), response.data);
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, data];
                case 6:
                    error_2 = _a.sent();
                    throw error_2;
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function getBdmService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_3, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: SENIOR_SERVICE_END_POINTS.GET_BDM,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_3 = _a.sent();
                    console.log(error_3);
                    errorMessage = error_3.response.data.message;
                    throw new Error(errorMessage);
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getNewSeniorListService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: SENIOR_SERVICE_END_POINTS.GET_NEW_SENIOR_LIST,
                            method: 'get',
                            params: params,
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_4 = _a.sent();
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    });
}
